import { Navigate } from "react-router-dom";

// import { AllowLeakFinder } from "../API";
import { RoleEnum, ROLES, RouteEnum } from "../common/models/enums";

interface IAppRoutesProps {
  allowedRoles: string[];
  role: RoleEnum;
  children: JSX.Element;
}

const LeakFinderRoleBasedRoute = ({
  allowedRoles,
  children,
  role,
}: IAppRoutesProps): JSX.Element => {
  const userRole = ROLES.find((r): boolean => r === role) ?? "";

  const allowed = allowedRoles?.includes(userRole);

  return allowed ? (
    <>{children}</>
  ) : (
    <Navigate to={RouteEnum.Unauthorized} replace />
  );
};

export default LeakFinderRoleBasedRoute;
